export default __webpack_public_path__ + "static/media/screen_webchat_1.9e705b60.png";